module.exports = __webpack_public_path__ + "img/no-picture-2-new.7d41453a.jpg";